import { render, staticRenderFns } from "./DocumentDesigner.vue?vue&type=template&id=5da2d1fc&"
import script from "./DocumentDesigner.vue?vue&type=script&lang=js&"
export * from "./DocumentDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports